var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('timeline',{ref:"timeline",staticClass:"planning",attrs:{"items":_vm.items,"groups":_vm.groups,"options":_vm.options,"events":['select']},on:{"select":_vm.select}})}
var staticRenderFns = []

export { render, staticRenderFns }